import { useEffect, useState } from "react";
import { Table, Button, Modal, Input, Select } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import Navbar from "../components/Navbar";
import appwriteClient from '../appwrite.config';
import { Databases, ID, Query } from "appwrite";
import { toast } from "react-toastify";

const { Option } = Select;

const ZoneRegister = () => {
  const databases = new Databases(appwriteClient);
  const [zones, setZones] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingZone, setEditingZone] = useState(null);
  const [fleetProfiles, setFleetProfiles] = useState([]);
  const [newZone, setNewZone] = useState({ zoneName: "", zoneDescription: "", fleetProfile: [] });

  useEffect(() => {
    databases.listDocuments("AppwriteCloudFEApp", "ZoneRegister", [Query.limit(500)])
      .then((response) => {setZones(response.documents)
    console.log(response.documents)})
      .catch((error) => {
        console.log(error);
        toast.error("Error getting zones!");
      });
  }, []);

  useEffect(() => {
    databases.listDocuments("AppwriteCloudFEApp", "65ea96670e2c9740a984", [Query.limit(500)])
      .then((res) => {
        const fleetArr = res.documents.map(fleet => ({ label: fleet.fleetname, value: fleet.$id }));
        setFleetProfiles(fleetArr);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Error fetching fleet profiles!");
      });
  }, []);

  const handleAddZone = async () => {
    databases.createDocument("AppwriteCloudFEApp", "ZoneRegister", ID.unique(), newZone)
      .then((res) => {
        toast.success("Zone created successfully!");
        setZones([...zones, res]);
        setNewZone({ zoneName: "", zoneDescription: "", fleetProfile: "" });
        setIsModalOpen(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error creating new zone!");
      });
  };

  const handleEditZone = () => {
    databases.updateDocument("AppwriteCloudFEApp", "ZoneRegister", editingZone.$id, editingZone)
      .then((res) => {
        toast.success("Zone updated successfully!");
        setZones(zones.map((zone) => (zone.$id === editingZone.$id ? res:zone)));
        setEditingZone(null);
        setIsModalOpen(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error updating zone!");
      });
  };

  const handleDeleteZone = (id) => {
    databases.deleteDocument("AppwriteCloudFEApp", "ZoneRegister", id)
      .then(() => {
        toast.success("Zone deleted successfully!");
        setZones(zones.filter((zone) => zone.$id !== id));
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error deleting zone!");
      });
  };

  const columns = [
    { title: "Zone Name", dataIndex: "zoneName", key: "zoneName" },
    { title: "Description", dataIndex: "zoneDescription", key: "zoneDescription" },
    { title: "Fleet Profile", dataIndex: "fleetProfile", key: "fleetProfile", render: (fleets)=>     {   if (!Array.isArray(fleets)) return "-"; 
        return fleets.map(fleet => fleet.fleetname).join(", ");}},
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <>
          <Button icon={<EditOutlined />} onClick={() => {
            
            const recordData = {};
            recordData.$id=record.$id;
            recordData.zoneName=record.zoneName;
            recordData.zoneDescription=record.zoneDescription;
            recordData.fleetProfile=record.fleetProfile.map((fleet)=>{
              return fleet.$id
            })
            setEditingZone(recordData);
            setIsModalOpen(true);
          }} style={{ marginRight: 8 }} />
          <Button icon={<DeleteOutlined />} danger onClick={() => handleDeleteZone(record.$id)} />
        </>
      ),
    },
  ];

  return (
    <>
      <Navbar page={"Zone Register"} />
      <div className="p-10">
        <Button type="primary" icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)}>
          Add Zone
        </Button>
        <Table dataSource={zones} columns={columns} rowKey="$id" style={{ marginTop: 20 }} />
        <Modal
          title={editingZone ? "Edit Zone" : "Add Zone"}
          open={isModalOpen}
          onCancel={() => {
            setIsModalOpen(false);
            setEditingZone(null);
          }}
          onOk={editingZone ? handleEditZone : handleAddZone}
        >
          <Input
            placeholder="Zone Name"
            value={editingZone ? editingZone.zoneName : newZone.zoneName}
            onChange={(e) =>
              editingZone
                ? setEditingZone({ ...editingZone, zoneName: e.target.value })
                : setNewZone({ ...newZone, zoneName: e.target.value })
            }
            style={{ marginBottom: 10 }}
          />
          <Input
            placeholder="Description"
            value={editingZone ? editingZone.zoneDescription : newZone.zoneDescription}
            onChange={(e) =>
              editingZone
                ? setEditingZone({ ...editingZone, zoneDescription: e.target.value })
                : setNewZone({ ...newZone, zoneDescription: e.target.value })
            }
            style={{ marginBottom: 10 }}
          />
          <Select
          
          mode="multiple"
            placeholder="Select Fleet Profile"
            filterOption={(inputValue, option) => {
                console.log(option)
               return option.children.toLowerCase().includes(inputValue.toLowerCase())
              }}
            value={editingZone ? editingZone.fleetProfile : newZone.fleetProfile}
            onChange={(value) =>
              editingZone
                ? setEditingZone({ ...editingZone, fleetProfile: value })
                : setNewZone({ ...newZone, fleetProfile: value })
            }
            className="my-3"
            style={{ width: "100%", marginBottom: 10 }}
          >
            {fleetProfiles.map((fleet) => (
              <Option  key={fleet.value} value={fleet.value}>{fleet.label}</Option>
            ))}
          </Select>
        </Modal>
      </div>
    </>
  );
};

export default ZoneRegister;
